import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { get } from 'lodash';

import Apis from '../services/Apis';

export default function useApidata() {

const { getSubcategoryPostdatalist, getBlogdetail, getRelatedBlogs} = Apis();
    const queryClient = useQueryClient();
    const navigate = useNavigate()

    // const initial_page = useSelector(state => state.globalslice.initial_page);
    // const sorting_data = useSelector(state => state.globalslice.sorting_data);
const useCategoryDatafilters = () => {
        return useQuery({
            queryKey: ['categorylistfilter'],
            queryFn: () => getSubcategoryPostdatalist(),
            cacheTime: Infinity,
            // enabled:!!post_type,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };
    const useCategoryData = (c_id) => {
        return useQuery({
            queryKey: ['categorylist', { c_id:c_id}],
            queryFn: () => getSubcategoryPostdatalist({ c_id:c_id}),
            cacheTime: Infinity,
            // enabled:!!post_type,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };

    const useBlogDetail = (slug) => {
         return useQuery({
            queryKey: ['getblogdetail', { 'slug':slug}],
            queryFn: () => getBlogdetail(slug),
            cacheTime: Infinity,
            enabled:!!slug,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const useRelatedBlogs = (c_id) => {
        return useQuery({
            queryKey: ['relatedblogs', { c_id:c_id}],
            queryFn: () => getRelatedBlogs({ c_id:c_id}),
            cacheTime: Infinity,
            enabled:!!c_id,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };
    

    return {
        useCategoryData,
        useCategoryDatafilters,
        useBlogDetail,
        useRelatedBlogs,
    }
};
